import React, {createContext, useContext} from 'react';
import {injectIntl} from '@meiko/react-intl';

/**
 * Context for sharing intl object throughout the component tree
 * This bridges the legacy @meiko/react-intl with modern React hooks
 */
const IntlContext = createContext(null);

/**
 * Provider component that receives intl via injectIntl and shares it via context
 */
const IntlProviderComponent = ({intl, children}) => {
	return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>;
};

export const IntlProvider = injectIntl(IntlProviderComponent);

/**
 * Custom hook to access intl object in functional components
 * @returns {Object} intl object with formatMessage, formatDate, etc.
 */
export const useIntl = () => {
	const intl = useContext(IntlContext);
	if (!intl) {
		throw new Error('useIntl must be used within an IntlProvider');
	}
	return intl;
};

export default IntlContext;
